// Dates and numbers in the site language. Chrome ships without Georgian Intl data (it silently
// formats "ka" as en-US), so Georgian gets hand-written month names.
import type { Lang } from "@shared/types";

const KA_MONTHS = ["იანვარი", "თებერვალი", "მარტი", "აპრილი", "მაისი", "ივნისი", "ივლისი", "აგვისტო", "სექტემბერი", "ოქტომბერი", "ნოემბერი", "დეკემბერი"];
const KA_MONTHS_SHORT = ["იან", "თებ", "მარ", "აპრ", "მაი", "ივნ", "ივლ", "აგვ", "სექ", "ოქტ", "ნოე", "დეკ"];

const intlOk = new Map<string, boolean>();
function hasIntl(lang: string): boolean {
  if (!intlOk.has(lang)) {
    try {
      intlOk.set(lang, Intl.DateTimeFormat.supportedLocalesOf([lang]).length > 0);
    } catch {
      intlOk.set(lang, false);
    }
  }
  return intlOk.get(lang)!;
}

const pad = (n: number) => String(n).padStart(2, "0");

/** 21 ოქტომბერი 2026 / 21 October 2026 */
export function formatDate(ts: number, lang: Lang, short = false): string {
  const d = new Date(ts);
  if (lang === "ka" || !hasIntl(lang)) {
    const m = (short ? KA_MONTHS_SHORT : KA_MONTHS)[d.getMonth()];
    return lang === "ka" ? `${d.getDate()} ${m} ${d.getFullYear()}` : d.toISOString().slice(0, 10);
  }
  return new Intl.DateTimeFormat(lang, { day: "numeric", month: short ? "short" : "long", year: "numeric" }).format(d);
}

/** 21 ოქტ, 14:05 */
export function formatDateTime(ts: number, lang: Lang): string {
  const d = new Date(ts);
  const time = `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  if (lang === "ka" || !hasIntl(lang)) return `${d.getDate()} ${KA_MONTHS_SHORT[d.getMonth()]}, ${time}`;
  return `${new Intl.DateTimeFormat(lang, { day: "numeric", month: "short" }).format(d)}, ${time}`;
}

/** 0.873 → "87%" */
export function formatPercent(x: number): string {
  return `${Math.round(x * 100)}%`;
}

/** 1834 ms → "1.8" (seconds, one decimal) */
export function formatSeconds(ms: number): string {
  return (Math.round(Math.max(0, ms) / 100) / 10).toFixed(1);
}
